<template>
  <div>
    <div class="is-flex is-align-items-end">
      <div class="field m-0 is-flex-grow-1">
        <label class="label">Max Salary Expectations</label>
        <div class="is-flex is-align-items-center">
          <div class="control is-flex-grow-1 mr-5">
            <input
              class="input"
              type="number"
              placeholder="between 5,000 to 100,000 ILS"
              min="5000"
              max="100000"
              :value="value"
              @input="updateValue"
              :class="{ field_error: isError }"
              @focusout="handleChange"
            />
          </div>
        </div>
      </div>
      <div>
        <button class="button is-primary" @click="assignMaxValue">99999</button>
      </div>
    </div>
    <p v-if="isError" class="is-size-7 has-text-danger">Please enter a value between 5,000 and 100,000 ILS.</p>
  </div>
</template>

<script>
export default {
  name: 'PositionMaxSalaryExpectations',
  props: {
    value: {
      type: [String, Number],
      validator: prop => typeof prop === 'number' || typeof prop === 'string' || prop === null
    },
    positionId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      isError: false
    }
  },
  watch: { value (value) { this.validateValue(value) } },
  mounted () {
    this.validateValue(this.value)
  },
  methods: {
    async assignMaxValue () {
      this.$emit('input', 99999)
      this.validateValue(99999)
      await this.saveValue(99999)
    },
    updateValue (event) {
      const value = event.target.value
      this.$emit('input', value)
      this.validateValue(value)
    },
    validateValue (value) {
      const numValue = Number(value)
      if (isNaN(numValue) || numValue < 5000 || numValue > 100000) {
        if (!this.isError) {
          this.isError = true
          this.$emit('error', true)
        }
      } else {
        if (this.isError) {
          this.isError = false
          this.$emit('error', false)
        }
      }
    },
    async handleChange () {
      await this.saveValue(this.value)
    },
    async saveValue (value) {
      try {
        if (this.isError) throw new Error('Validation error')
        await this.$network_utils.updatePosition({ position_id: this.positionId, max_salary_expectations: value, active_at: new Date() })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'Failed to update position' })
        this.$emit('error', true)
      }
    }
  }
}
</script>
